export default __webpack_public_path__ + "27099f24bd199e87b5e0afb692090d81.png";